"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StringBuffer = _interopRequireDefault(require("../../../../java/lang/StringBuffer"));

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Position = _interopRequireDefault(require("./Position"));

var _TopologyException = _interopRequireDefault(require("../geom/TopologyException"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _SimplePointInAreaLocator = _interopRequireDefault(require("../algorithm/locate/SimplePointInAreaLocator"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeEndStar =
/*#__PURE__*/
function () {
  function EdgeEndStar() {
    _classCallCheck(this, EdgeEndStar);

    EdgeEndStar.constructor_.apply(this, arguments);
  }

  _createClass(EdgeEndStar, [{
    key: "getNextCW",
    value: function getNextCW(ee) {
      this.getEdges();

      var i = this._edgeList.indexOf(ee);

      var iNextCW = i - 1;
      if (i === 0) iNextCW = this._edgeList.size() - 1;
      return this._edgeList.get(iNextCW);
    }
  }, {
    key: "propagateSideLabels",
    value: function propagateSideLabels(geomIndex) {
      var startLoc = _Location.default.NONE;

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();
        if (label.isArea(geomIndex) && label.getLocation(geomIndex, _Position.default.LEFT) !== _Location.default.NONE) startLoc = label.getLocation(geomIndex, _Position.default.LEFT);
      }

      if (startLoc === _Location.default.NONE) return null;
      var currLoc = startLoc;

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();
        if (label.getLocation(geomIndex, _Position.default.ON) === _Location.default.NONE) label.setLocation(geomIndex, _Position.default.ON, currLoc);

        if (label.isArea(geomIndex)) {
          var leftLoc = label.getLocation(geomIndex, _Position.default.LEFT);
          var rightLoc = label.getLocation(geomIndex, _Position.default.RIGHT);

          if (rightLoc !== _Location.default.NONE) {
            if (rightLoc !== currLoc) throw new _TopologyException.default("side location conflict", e.getCoordinate());

            if (leftLoc === _Location.default.NONE) {
              _Assert.default.shouldNeverReachHere("found single null side (at " + e.getCoordinate() + ")");
            }

            currLoc = leftLoc;
          } else {
            _Assert.default.isTrue(label.getLocation(geomIndex, _Position.default.LEFT) === _Location.default.NONE, "found single null side");

            label.setLocation(geomIndex, _Position.default.RIGHT, currLoc);
            label.setLocation(geomIndex, _Position.default.LEFT, currLoc);
          }
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var it = this.iterator();
      if (!it.hasNext()) return null;
      var e = it.next();
      return e.getCoordinate();
    }
  }, {
    key: "print",
    value: function print(out) {
      _System.default.out.println("EdgeEndStar:   " + this.getCoordinate());

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        e.print(out);
      }
    }
  }, {
    key: "isAreaLabelsConsistent",
    value: function isAreaLabelsConsistent(geomGraph) {
      this.computeEdgeEndLabels(geomGraph.getBoundaryNodeRule());
      return this.checkAreaLabelsConsistent(0);
    }
  }, {
    key: "checkAreaLabelsConsistent",
    value: function checkAreaLabelsConsistent(geomIndex) {
      var edges = this.getEdges();
      if (edges.size() <= 0) return true;
      var lastEdgeIndex = edges.size() - 1;
      var startLabel = edges.get(lastEdgeIndex).getLabel();
      var startLoc = startLabel.getLocation(geomIndex, _Position.default.LEFT);

      _Assert.default.isTrue(startLoc !== _Location.default.NONE, "Found unlabelled area edge");

      var currLoc = startLoc;

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();

        _Assert.default.isTrue(label.isArea(geomIndex), "Found non-area edge");

        var leftLoc = label.getLocation(geomIndex, _Position.default.LEFT);
        var rightLoc = label.getLocation(geomIndex, _Position.default.RIGHT);

        if (leftLoc === rightLoc) {
          return false;
        }

        if (rightLoc !== currLoc) {
          return false;
        }

        currLoc = leftLoc;
      }

      return true;
    }
  }, {
    key: "findIndex",
    value: function findIndex(eSearch) {
      this.iterator();

      for (var i = 0; i < this._edgeList.size(); i++) {
        var e = this._edgeList.get(i);

        if (e === eSearch) return i;
      }

      return -1;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this.getEdges().iterator();
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      if (this._edgeList === null) {
        this._edgeList = new _ArrayList.default(this._edgeMap.values());
      }

      return this._edgeList;
    }
  }, {
    key: "getLocation",
    value: function getLocation(geomIndex, p, geom) {
      if (this._ptInAreaLocation[geomIndex] === _Location.default.NONE) {
        this._ptInAreaLocation[geomIndex] = _SimplePointInAreaLocator.default.locate(p, geom[geomIndex].getGeometry());
      }

      return this._ptInAreaLocation[geomIndex];
    }
  }, {
    key: "toString",
    value: function toString() {
      var buf = new _StringBuffer.default();
      buf.append("EdgeEndStar:   " + this.getCoordinate());
      buf.append("\n");

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        buf.append(e);
        buf.append("\n");
      }

      return buf.toString();
    }
  }, {
    key: "computeEdgeEndLabels",
    value: function computeEdgeEndLabels(boundaryNodeRule) {
      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        ee.computeLabel(boundaryNodeRule);
      }
    }
  }, {
    key: "computeLabelling",
    value: function computeLabelling(geomGraph) {
      this.computeEdgeEndLabels(geomGraph[0].getBoundaryNodeRule());
      this.propagateSideLabels(0);
      this.propagateSideLabels(1);
      var hasDimensionalCollapseEdge = [false, false];

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();

        for (var geomi = 0; geomi < 2; geomi++) {
          if (label.isLine(geomi) && label.getLocation(geomi) === _Location.default.BOUNDARY) hasDimensionalCollapseEdge[geomi] = true;
        }
      }

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();

        for (var geomi = 0; geomi < 2; geomi++) {
          if (label.isAnyNull(geomi)) {
            var loc = _Location.default.NONE;

            if (hasDimensionalCollapseEdge[geomi]) {
              loc = _Location.default.EXTERIOR;
            } else {
              var p = e.getCoordinate();
              loc = this.getLocation(geomi, p, geomGraph);
            }

            label.setAllLocationsIfNull(geomi, loc);
          }
        }
      }
    }
  }, {
    key: "getDegree",
    value: function getDegree() {
      return this._edgeMap.size();
    }
  }, {
    key: "insertEdgeEnd",
    value: function insertEdgeEnd(e, obj) {
      this._edgeMap.put(e, obj);

      this._edgeList = null;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndStar;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeEndStar;
}();

exports.default = EdgeEndStar;

EdgeEndStar.constructor_ = function () {
  this._edgeMap = new _TreeMap.default();
  this._edgeList = null;
  this._ptInAreaLocation = [_Location.default.NONE, _Location.default.NONE];
};